import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
    if (
        (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.HANDLE_REDIRECT_END) &&
        event.payload?.account
    ) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
        console.log("Login successful, account set:", account.username);
    }
    
    if (event.eventType === EventType.LOGOUT_SUCCESS) {
        console.log("Logout successful");
    }
    
    if (event.eventType === EventType.LOGIN_FAILURE) {
        console.error("Login failed:", event.error);
    }
    
    if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        console.error("Token acquisition failed:", event.error);
    }
});

export const AuthProvider = ({ children }) => {
    return (
        <MsalProvider instance={msalInstance}>
            {children}
        </MsalProvider>
    );
};
